const $ = jQuery.noConflict();

export default class MainSlider {
    constructor() {
        this.slider = $('.main-slider-wrapper');
        this.nextTrigger = this.slider.find('.next-post');
    }

    init() {
        const slickObject = this.slider.slick({
            arrows: false,
            dots: true,
            fade: true,
            swipe: true
        });

        this.nextTrigger.on('click', () => {
            slickObject.slick('slickNext')
        })
    }

}
